import LotStatus from '../enums/lotStatus';

function resolveLotStatus(rawStatus) {
  const normalized = rawStatus?.toLowerCase() ?? '';
  return (LotStatus.fromKey(normalized) ?? LotStatus.NotFound).toString();
}

export default resolveLotStatus;
